module.exports = __webpack_public_path__ + "aab683cb107b96c008c35bedca15dc65.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-BoldItalic.woff
// module id = 712
// module chunks = 0